import { isBoolean, isEqual, isFunction, isNumber, isString, isUndefined } from 'lodash';
import { EventBroker } from './EventBroker';
import { EMPTY_ARRAY } from '../arrayTools';
export class ReadablePropEventBroker extends EventBroker {
    constructor(emitter, initialValue, options) {
        super(emitter, options);
        this.metadata = new Map();
        const validators = options?.validators ?? [];
        this._value = initialValue;
        this._validator = options?.validator;
        this._serializer = options?.serializer;
        this.setMetadataList(validators.map(validator => validator.metadata));
        const validatorValues = this.extractValidationsAndSetMetadata(validators);
        this._validators = validatorValues;
        this.violationsChanged = new EventBroker(emitter);
        this._violationResults = EMPTY_ARRAY;
        this.performValidation();
    }
    getMetadataValue(key) {
        let value;
        if (this.metadata.has(key)) {
            value = this.metadata.get(key);
        }
        return value;
    }
    setMetadataList(metadataList) {
        metadataList.forEach(metadata => {
            for (const key in metadata) {
                if (Object.prototype.hasOwnProperty.call(metadata, key)) {
                    const value = metadata[key];
                    this.setMetadataValue(key, value);
                }
            }
        });
    }
    extractValidationsAndSetMetadata(validators) {
        return validators.map(validator => validator.validator);
    }
    setMetadataValue(key, value) {
        this.metadata.set(key, value);
    }
    isValid() {
        return this._violationResults.length === 0;
    }
    getViolations() {
        return this._violationResults.length > 0 ? this._violationResults : undefined;
    }
    _getValidator() {
        let validatorFunc = () => true;
        switch (this._validator) {
            case 'boolean':
                validatorFunc = isBoolean;
                break;
            case 'string':
                validatorFunc = isString;
                break;
            case 'number':
                validatorFunc = isNumber;
                break;
            case 'notUndefined':
                validatorFunc = value => !isUndefined(value);
                break;
            default:
                if (isFunction(this._validator)) {
                    validatorFunc = this._validator;
                }
                break;
        }
        return validatorFunc;
    }
    serialize() {
        let itemSerialized;
        const value = this.get();
        if (isFunction(this._serializer)) {
            itemSerialized = this._serializer(this);
        }
        else {
            switch (typeof value) {
                case 'string':
                case 'number':
                case 'boolean':
                    itemSerialized = String(value);
                    break;
                case 'object':
                default:
                    itemSerialized = undefined;
            }
        }
        return itemSerialized;
    }
    emitValueChanged() {
        this.emit({ _this: this.getEmitter(), value: this._value });
    }
    emitValidationsChanged() {
        this.violationsChanged.emit(this._violationResults);
    }
    performValidation() {
        const results = this._validators?.map(validator => validator(this._value)).filter(Boolean) ?? this._violationResults;
        if (!isEqual(results, this._violationResults)) {
            this._violationResults = results;
            this.emitValidationsChanged();
        }
    }
    setValueInner(newValue, options) {
        this._value = newValue;
        if (!options?.silent) {
            this.emitValueChanged();
        }
        this.performValidation();
    }
    get() {
        return this._value;
    }
}
//# sourceMappingURL=ReadablePropEventBroker.js.map